// extracted by mini-css-extract-plugin
export var chevron = "_k2-2";
export var dropdownItems = "_k2-0";
export var item = "_k2-1";